import React from 'react';
import { govTransactionSide } from '../GovTrades/ColumnsDef/formatTransaction';

export type TradeTypeTone = 'buy' | 'neutral' | 'sell';

const toneClass: Record<TradeTypeTone, string> = {
  buy: 'bg-green-100 text-green-700',
  neutral: 'bg-gray-100 text-gray-600',
  sell: 'bg-red-100 text-red-700',
};

export const TradeTypeBadge: React.FC<{ label?: string | null; tone?: TradeTypeTone }> = ({
  label,
  tone = 'neutral',
}) => (
  <span className={`inline-block rounded px-2 py-0.5 text-xs font-semibold ${toneClass[tone]}`}>{label || '—'}</span>
);

export const insiderTradeTypeTone = (status?: string | null): TradeTypeTone => {
  if (status === 'BUY') return 'buy';
  if (status === 'SELL') return 'sell';
  return 'neutral';
};

export const govTransactionTypeTone = (transactionType?: string | null): TradeTypeTone =>
  govTransactionSide(transactionType) ?? 'neutral';

export default TradeTypeBadge;
